import PropTypes from 'prop-types';
import React from 'react';
import MainPage from '../../components/MainPage.react';
import CrossChannelStore from '../../stores/CrossChannelStore';
import CrossChannelActions from '../../actions/CrossChannelActions';
import CurrentOrganizationIdStore from '../../stores/CurrentOrganizationIdStore';
import QueryStore from '../../stores/QueryStore';

// TODO: I Don't like passing in OrgID here -- I'd much rather have it handled
// in the stores + Action Creators, but I'm trying to avoid a messy merge.
// Ideally organization is not even relevant in the CrossChannel components
function getState() {
  const organizationId = CurrentOrganizationIdStore.getState();
  return {
    organizationId,
    job: CrossChannelStore.getJobForOrganization(organizationId),
    availableTargetUniverses: QueryStore.getTaggedQueriesForOrganization('universe', organizationId),
    availableUpliftScores: QueryStore.getTaggedQueriesForOrganization('uplift_score', organizationId),
    advancedSettings: CrossChannelStore.showAdvancedSettings(),
  };
}

export default class CrossChannelNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = getState();
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    CrossChannelStore.addChangeListener(this._onChange);
    this.orgIdSubscription = CurrentOrganizationIdStore.addListener(this._onChange());
    this.queryStoreSubscription = QueryStore.addListener(this._onChange);
    CrossChannelActions.loadSourceTables();
  }

  componentWillUnmount() {
    CrossChannelStore.removeChangeListener(this._onChange);
    this.orgIdSubscription.remove();
    this.queryStoreSubscription.remove();
  }

  _onChange() {
    this.setState(getState());
  }

  render() {
    return (
      <MainPage>
        <h3>Cross Channel Analysis</h3>
        {
          React.cloneElement(this.props.children, {
            organizationId: this.state.organizationId,
            job: this.state.job,
            availableTargetUniverses: this.state.availableTargetUniverses,
            availableUpliftScores: this.state.availableUpliftScores,
            advancedSettings: this.state.advancedSettings,
          })
        }
      </MainPage>
    );
  }
}

CrossChannelNew.propTypes = {
  children: PropTypes.object,
};
